import { Component, EventEmitter, inject, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { RouterModule } from '@angular/router'
import { IconLegacyComponent, unwrapData } from '@ftr/foundation'
import { DropdownMenuLegacyComponent, StaticMenuItem } from '@ftr/menus'
import { AppPaths } from '@ftr/routing-paths'
import { UserAvatarComponent, UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { SideNavDisplayMode } from '../../navigation'

export const USER_AND_ORG_MENU_ITEMS = [
  { title: 'Browse Organizations', path: [`/${AppPaths.NotFound}`] },
  { title: 'Create Organization', path: [`/${AppPaths.NotFound}`] },
] satisfies StaticMenuItem[]

@Component({
  selector: 'ftr-user-and-org-dropdown',
  templateUrl: './user-and-org-dropdown.component.html',
  styleUrls: ['./user-and-org-dropdown.component.css'],
  encapsulation: ViewEncapsulation.None,
  imports: [DropdownMenuLegacyComponent, UserAvatarComponent, IconLegacyComponent, RouterModule],
})
export class UserAndOrgDropdownComponent {
  private readonly store = inject(Store)

  @Input() collapsed: boolean = false
  @Input() displayMode: SideNavDisplayMode = 'DEFAULT'
  @Output() dropdownOpened = new EventEmitter<void>()

  @ViewChild(DropdownMenuLegacyComponent) protected dropdown: DropdownMenuLegacyComponent

  protected readonly currentUser = toSignal(this.store.select(UserState.user).pipe(unwrapData()))
  protected readonly appPaths = AppPaths

  protected readonly menuItems: StaticMenuItem[] = USER_AND_ORG_MENU_ITEMS

  protected readonly componentSelector = 'ftr-user-and-org-dropdown'

  toggle(): void {
    this.dropdown.toggle()
  }
}
